module.exports = __webpack_public_path__ + "img/Group 1138@3x .8dbf2ad6.png";